'use client';
import { type PostUserLoginEmailPayload, sessionAtom } from '@capsicum/common';
import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

import { showEmailInputFormAtom } from '../atoms';
import { postLoginEmail, postLoginMobile } from '../data-access';

import type { SmsLoginParams } from '../models';

export const useCodeVerification = () => {
	const setSessionRefresh = useSetAtom(sessionAtom);
	const setShowEmailInput = useSetAtom(showEmailInputFormAtom);

	const afterSuccessOnVerifyAndLogin = useCallback(() => {
		setShowEmailInput(true);
	}, [setShowEmailInput]);

	const verifyAndLoginSms = useCallback(
		async (loginParams: SmsLoginParams) => {
			const data = await postLoginMobile(loginParams);

			setSessionRefresh({
				...data,
				deviceUid: loginParams.deviceUid
			});

			afterSuccessOnVerifyAndLogin();

			return data;
		},
		[afterSuccessOnVerifyAndLogin, setSessionRefresh]
	);

	const verifyAndLoginEmail = useCallback(
		async (loginParams: PostUserLoginEmailPayload) => {
			const data = await postLoginEmail(loginParams);

			setSessionRefresh({
				...data,
				deviceUid: loginParams.deviceUid
			});

			afterSuccessOnVerifyAndLogin();

			return data;
		},
		[afterSuccessOnVerifyAndLogin, setSessionRefresh]
	);

	return { verifyAndLoginEmail, verifyAndLoginSms };
};
